import { Component } from '@angular/core';

/** Static "How to use" guide for the spending dashboard, shown in a dialog from the filter bar. */
@Component({
  selector: 'ppl-spending-dashboard-help',
  standalone: true,
  templateUrl: './spending-dashboard-help.component.html',
  styleUrl: './spending-dashboard-help.component.css'
})
export class SpendingDashboardHelpComponent {}
